import { observer } from 'mobx-react-lite';

import { FileField as CoreFileField } from '@components/file-field';
import { asteriskLabel } from '@utils/strings';

import { useStore } from 'models/stores';

export default observer(({ form, required = false, field = '' }) => {
  const {
    uiStore: { t },
  } = useStore();
  const file = form[field];
  const label = t(`apply_${field}_label`);
  const error = form.errors.get(field) ? t(form.errors.get(field).error) : '';

  return (
    <CoreFileField
      label={asteriskLabel(label, required)}
      placeholder={t('upload_file')}
      defaultValue={file || undefined}
      onChange={(newFile) => form.set(field, newFile)}
      error={error}
      isDisabled={form.disabled}
    />
  );
});
